export default {
	backgroundColor: {
		type: 'string',
		default: '#8A50FF',
	},
	width: {
		type: 'string',
		default: '100%'
	},
	height: {
		type: 'string',
		default: '100%'
	},
	skewX: {
		type: 'number',
		default: 0,
	},
	skewY: {
		type: 'number',
		default: 0,
	},
	topPosition: {
		type: 'number',
		default: 0,
	},
	bottomPosition: {
		type: 'number',
		default: 0,
	},
	leftPosition: {
		type: 'string',
		default: 0,
	},
	rightPosition: {
		type: 'string',
		default: 0,
	},
	radius: {
		type: 'string',
		default: 0
	},
	padding: {
		type: 'string',
		default: '2rem'
	},
	margin: {
		type: 'string',
		default: '0'
	},
	preset: {
		type: 'string',
		default: 'auto'
	}
};
